import axios from 'axios';
// import router from '../router';

// Helper to get base URL and token
function getApiConfig() {
  const userToken = localStorage.getItem('userToken');
  const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
  return { userToken, baseURL };
}

const state = {
  isUploading: false,
  uploadError: null,
  uploadSuccess: false,
};

const mutations = {
  SET_UPLOADING(state, isUploading) {
    state.isUploading = isUploading;
    state.uploadError = null;
    state.uploadSuccess = false;
  },
  SET_UPLOAD_ERROR(state, error) {
    state.isUploading = false;
    state.uploadError = error;
    state.uploadSuccess = false;
  },
  SET_UPLOAD_SUCCESS(state) {
    state.isUploading = false;
    state.uploadError = null;
    state.uploadSuccess = true;
  },
  CLEAR_UPLOAD_STATUS(state) {
    state.isUploading = false;
    state.uploadError = null;
    state.uploadSuccess = false;
  }
};

const actions = {
  async uploadLogo({ commit }, file) {
    const { baseURL, userToken } = getApiConfig();
    if (!userToken) {
      commit('SET_UPLOAD_ERROR', 'User not authenticated.');
      router.push({ name: 'login' });
      return;
    }

    commit('SET_UPLOADING', true);

    // We must use FormData to send a file
    const formData = new FormData();
    formData.append('logo', file); // 'logo' must match the API's expected field name

    try {
      const response = await axios.post(`${baseURL}/upload-logo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Critical for file uploads
          'Authorization': `Bearer ${userToken}`,
        },
      });
      
      commit('SET_UPLOAD_SUCCESS');
      return response.data;

    } catch (error) {
      console.error('Error uploading logo:', error);
      const errorMessage = error.response?.data?.error || 'An unknown error occurred during upload.';
      commit('SET_UPLOAD_ERROR', errorMessage);
      throw error;
    }
  },

  clearUploadStatus({ commit }) {
    commit('CLEAR_UPLOAD_STATUS');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

